/** Utils for create audit help
 * 1. Audits To Create - getAuditsToCreate
 * 2. Locations to create Audits - getAuditLocationsToCreate
 * 3. Assets for the audits - getAuditAssetsToCreate
 * 4. Assignments for the audits - getAuditAssignmentsToCreate
 */

import { removeTimeZone } from "../../common/lib/helpers";

export const getAuditsToCreate = (
    data,
    auditsCreate,
    createdBy,
    groupId,
    orgId
) => {
    const { filters, endDate, startDate } = auditsCreate;
    return data
        .filter((item) => item.selected)
        .map((item) => ({
            ...item,
            createdBy,
            endDate: removeTimeZone(endDate),
            filter: filters,
            groupId: groupId,
            organisation: orgId,
            startDate: removeTimeZone(startDate),
            name: item.name
        }));
};

export const getAuditLocationsToCreate = (data, audits) => {
    let auditIndices = {};

    return data.reduce((aggregate, item) => {
        const audit = audits.find(
            (audit) =>
                audit.branch.id === item.branch && !auditIndices[audit.id]
        );
        auditIndices[audit.id] = true;
        audit &&
            aggregate.push({
                audit: audit.id,
                location: item.location
            });

        return aggregate;
    }, []);
};

export const getAuditAssetsToCreate = (
    data,
    audits,
    auditLocations,
    createdBy
) => {
    return data.reduce((aggregate, item) => {
        const audit = audits.find((audit) => audit.branch.id === item.branch);
        if (audit) {
            const auditLocation = auditLocations.find(
                (auditLocation) =>
                    auditLocation.audit === audit.id &&
                    item.location === auditLocation.location
            );
            auditLocation &&
                aggregate.push({
                    asset: item.asset.id,
                    auditLocation: auditLocation.id,
                    createdBy,
                    excludeFrom: item.excludeFrom,
                    excludeUntil: item.excludeUntil,
                    isExpected: item.isExpected,
                    isLive: item.isLive,
                    isMandatory: item.isMandatory,
                    isRelated: item.isRelated
                });
        }
        return aggregate;
    }, []);
};

export const getAuditAssignmentsToCreate = (
    data,
    audits,
    auditLocations,
    createdBy
) => {
    let auditIndices = {};
    return data.reduce((aggregate, item) => {
        const audit = audits.find(
            (audit) =>
                audit.branch.id === item.branch && !auditIndices[audit.id]
        );
        if (audit) {
            const filtered = auditLocations.filter(
                (auditLocation) =>
                    auditLocation.audit === audit.id &&
                    item.location === auditLocation.location
            );
            auditIndices[audit.id] = true;
            filtered.forEach((auditLocation) => {
                aggregate.push(
                    ...item.userLocations
                        .filter(
                            ({ location }) =>
                                location === auditLocation.location
                        )
                        .map(({ user }) => ({
                            auditLocation: auditLocation.id,
                            auditor: user,
                            createdBy
                        }))
                );
            });
        }
        return aggregate;
    }, []);
};
export default {
    getAuditsToCreate,
    getAuditLocationsToCreate,
    getAuditAssetsToCreate,
    getAuditAssignmentsToCreate
};
